import { render, staticRenderFns } from "./product-distribution.vue?vue&type=template&id=73d64dda&"
import script from "./product-distribution.vue?vue&type=script&lang=js&"
export * from "./product-distribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports